const attach = (element) => {
    const select = element.querySelector('select')
    const submit = element.querySelector('button')

    select.addEventListener("change", () => {
        submit.click()
        element.classList.add('changing')
    })
}

document.querySelectorAll('.switch-center').forEach(attach)
